// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3353) return "css/3353-80bc0bbc.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + "a71c6bfd" + ".css";
};